// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f69f9573","732":"71a101a2"}[chunkId] + ".chunk.js";
};